/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientAccessGroup from './patient-access-group';
import PatientAccessGroupDetail from './patient-access-group-detail';
import PatientAccessGroupUpdate from './patient-access-group-update';
import PatientAccessGroupDeleteDialog from './patient-access-group-delete-dialog';

const PatientAccessGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientAccessGroup />} />
    <Route path="new" element={<PatientAccessGroupUpdate />} />
    <Route path=":id">
      <Route index element={<PatientAccessGroupDetail />} />
      <Route path="edit" element={<PatientAccessGroupUpdate />} />
      <Route path="delete" element={<PatientAccessGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientAccessGroupRoutes;
